module.exports = __webpack_public_path__ + "static/media/0025_IMG_LES_MURS_P21_UNI_TROPICAL_CHEVRON.76c0c68b.webp";